/**
 * Keyboard / gamepad / touch input (Nn, In) + UI screen stack (Rn).
 */
import { E } from "../math.js";
import { V, bt } from "../ui/dom.js";

export const kn = {
        Space: [`jump`],
        Tab: [`view`],
        Enter: [`confirm`],
        NumpadEnter: [`confirm`],
        Escape: [`pause`],
        KeyP: [`pause`],
        Backspace: [`back`],
        KeyC: [`photo`],
        KeyF: [`fullscreen`],
        KeyM: [`mute`],
        ArrowLeft: [`danceLeft`, `navLeft`],
        ArrowUp: [`danceUp`, `navUp`],
        ArrowRight: [`danceRight`, `navRight`],
        ArrowDown: [`danceDown`, `navDown`],
        KeyA: [`navLeft`],
        KeyW: [`navUp`],
        KeyD: [`navRight`],
        KeyS: [`navDown`]
    };
export const An = {
        0: [`jump`, `confirm`],
        1: [`back`],
        8: [`photo`],
        9: [`pause`],
        11: [`view`],
        16: [`pause`],
        12: [`danceUp`, `navUp`],
        13: [`danceDown`, `navDown`],
        14: [`danceLeft`, `navLeft`],
        15: [`danceRight`, `navRight`]
    };
export const jn = .0022;
export const Mn = 2.4;
export class Nn {
        canvas;
        device = `keyboard`;
        touchUI = !1;
        held = new Set;
        lookX = 0;
        lookY = 0;
        listeners = [];
        padPrev = [];
        padAxes = [0, 0, 0, 0];
        padIndex = null;
        navRepeat = {
            dir: ``,
            next: 0
        };
        triggerSprint = !1;
        dragging = !1;
        l3Sprint = !1;
        lastL3 = !1;
        fullTilt = 0;
        pad = null;
        touchMove = {
            x: 0,
            z: 0,
            sprint: !1
        };
        touchLookX = 0;
        touchLookY = 0;
        constructor(e) {
            this.canvas = e, window.addEventListener(`keydown`, e => this.onKey(e, !0), {
                capture: !0
            }), window.addEventListener(`keyup`, e => this.onKey(e, !1), {
                capture: !0
            }), window.addEventListener(`blur`, () => this.held.clear()), document.addEventListener(`visibilitychange`, () => this.held.clear()), e.addEventListener(`mousedown`, e => {
                (e.button === 0 || e.button === 2) && (this.dragging = !0)
            }), window.addEventListener(`mouseup`, () => this.dragging = !1), e.addEventListener(`contextmenu`, e => e.preventDefault()), window.addEventListener(`mousemove`, e => {
                (document.pointerLockElement === this.canvas || this.dragging) && (Math.abs(e.movementX) > 400 || Math.abs(e.movementY) > 400 || (this.lookX += e.movementX, this.lookY += e.movementY, this.device = `keyboard`))
            }), window.addEventListener(`gamepadconnected`, e => {
                this.padIndex = e.gamepad.index
            }), window.addEventListener(`gamepaddisconnected`, e => {
                this.padIndex === e.gamepad.index && (this.padIndex = null)
            })
        }
        on(e) {
            this.listeners.push(e)
        }
        emit(e, t, n) {
            for (let r of this.listeners) r({
                action: e,
                time: t,
                device: n
            })
        }
        onKey(e, t) {
            if (t) {
                if (this.device = `keyboard`, [`Space`, `ArrowUp`, `ArrowDown`, `ArrowLeft`, `ArrowRight`, `Tab`].includes(e.code) && e.preventDefault(), e.repeat) {
                    (kn[e.code]?.filter(e => e.startsWith(`nav`)))?.forEach(t => this.emit(t, e.timeStamp, `keyboard`));
                    return
                }
                this.held.add(e.code);
                for (let t of kn[e.code] ?? []) this.emit(t, e.timeStamp || performance.now(), `keyboard`)
            } else this.held.delete(e.code)
        }
        lockPointer() {
            if (this.touchUI || document.pointerLockElement === this.canvas) return;
            let e = () => {
                try {
                    let e = this.canvas.requestPointerLock?.();
                    e instanceof Promise && e.catch(() => void 0)
                } catch {}
            };
            try {
                let t = this.canvas.requestPointerLock?.({
                    unadjustedMovement: !0
                });
                t instanceof Promise && t.catch(e)
            } catch {
                e()
            }
        }
        intentionalUnlock = !1;
        unlockPointer() {
            document.pointerLockElement && (this.intentionalUnlock = !0, document.exitPointerLock?.())
        }
        consumeIntentionalUnlock() {
            let e = this.intentionalUnlock;
            return this.intentionalUnlock = !1, e
        }
        get pointerLocked() {
            return document.pointerLockElement === this.canvas
        }
        setTouchMove(e, t, n) {
            this.touchMove = {
                x: e,
                z: t,
                sprint: n
            }, (e || t) && (this.device = `touch`)
        }
        addTouchLook(e, t) {
            this.touchLookX += e, this.touchLookY += t, this.device = `touch`
        }
        touchAction(e) {
            this.device = `touch`, this.emit(e, performance.now(), `touch`)
        }
        rumble(e, t, n) {
            let r = this.pad?.vibrationActuator;
            r?.playEffect && this.device === `gamepad` && r.playEffect(`dual-rumble`, {
                duration: n,
                strongMagnitude: e,
                weakMagnitude: t
            }).catch(() => void 0)
        }
        poll() {
            let e = [];
            try {
                e = navigator.getGamepads ? [...navigator.getGamepads()] : []
            } catch {
                e = []
            }
            let t = null;
            this.padIndex !== null && (t = e[this.padIndex] ?? null);
            for (let n of e) n && n.connected && n !== t && (n.buttons.some(e => e.pressed) || n.axes.some(e => Math.abs(e) > .5)) && (t = n);
            if (!t)
                for (let n of e) n && n.connected && (t = n);
            if (this.pad = t, !t) {
                this.padAxes = [0, 0, 0, 0];
                return
            }
            this.padIndex = t.index;
            let n = performance.now(),
                r = t.timestamp > 0 && Math.abs(n - t.timestamp) < 100 ? t.timestamp : n,
                i = t.buttons.map(e => e.pressed || e.value > .5),
                a = !1;
            i.forEach((e, t) => {
                if (e && !this.padPrev[t]) {
                    a = !0;
                    for (let e of An[t] ?? []) this.emit(e, r, `gamepad`)
                }
            }), this.padPrev = i, this.triggerSprint = (t.buttons[6]?.value ?? 0) > .3 || (t.buttons[7]?.value ?? 0) > .3 || !!t.buttons[5]?.pressed;
            let o = !!t.buttons[10]?.pressed;
            o && !this.lastL3 && (this.l3Sprint = !this.l3Sprint), this.lastL3 = o;
            let s = (e, t, n, r) => {
                    let i = Math.hypot(e, t);
                    if (i < n) return [0, 0];
                    let a = Math.min(1, (i - n) / (1 - n)) ** +r / i;
                    return [e * a, t * a]
                },
                [c, l] = s(t.axes[0] ?? 0, t.axes[1] ?? 0, .16, 1),
                [u, d] = s(t.axes[2] ?? 0, t.axes[3] ?? 0, .14, 1.7);
            this.padAxes = [c, l, u, d], this.padAxes.some(e => e !== 0) && (a = !0), a && (this.device = `gamepad`), Math.hypot(this.padAxes[0], this.padAxes[1]) < .2 && (this.l3Sprint = !1);
            let [f, p] = this.padAxes, m = Math.abs(f) > .6 ? f > 0 ? `navRight` : `navLeft` : Math.abs(p) > .6 ? p > 0 ? `navDown` : `navUp` : ``;
            m && (m !== this.navRepeat.dir || n >= this.navRepeat.next) ? (this.emit(m, n, `gamepad`), this.navRepeat = {
                dir: m,
                next: n + (m === this.navRepeat.dir ? 110 : 380)
            }) : m || (this.navRepeat.dir = ``)
        }
        move() {
            let e = 0,
                t = 0;
            this.held.has(`KeyA`) && --e, this.held.has(`KeyD`) && (e += 1), this.held.has(`KeyW`) && (t += 1), this.held.has(`KeyS`) && --t, e += this.padAxes[0] + this.touchMove.x, t += -this.padAxes[1] + this.touchMove.z;
            let n = this.held.has(`ShiftLeft`) || this.held.has(`ShiftRight`) || this.triggerSprint || this.l3Sprint || this.touchMove.sprint;
            return {
                x: e,
                z: t,
                sprint: n
            }
        }
        look(e) {
            let t = Math.hypot(this.padAxes[2], this.padAxes[3]);
            this.fullTilt = t > .95 ? Math.min(1, this.fullTilt + e * 2.5) : 0;
            let n = Mn * e * (1 + this.fullTilt * .6),
                r = 2.4 / Math.max(320, Math.min(window.innerWidth, window.innerHeight)),
                i = this.lookX * jn + this.padAxes[2] * n + this.touchLookX * r,
                a = this.lookY * jn + this.padAxes[3] * n * .7 + this.touchLookY * r * .8;
            return this.lookX = this.lookY = this.touchLookX = this.touchLookY = 0, {
                dx: Number.isFinite(i) ? i : 0,
                dy: Number.isFinite(a) ? a : 0
            }
        }
    };
export const Pn = .145;
export const Fn = 1.3;
export class In {
        input;
        el;
        stickEl;
        knob;
        danceEl;
        stick = null;
        looks = new Map;
        hidden = !1;
        clubMode = !1;
        constructor(e) {
            this.input = e, this.knob = V(`div`, {
                class: `t-knob`
            }), this.stickEl = V(`div`, {
                class: `t-stick idle`
            }, V(`div`, {
                class: `t-ring`
            }), this.knob);
            let t = (e, t, n, r) => {
                    let i = V(`button`, {
                        class: `t-btn ${e}`,
                        type: `button`,
                        "aria-label": n
                    }, bt(t));
                    i.addEventListener(`pointerdown`, e => {
                        e.preventDefault(), e.stopPropagation(), i.classList.add(`down`), r()
                    });
                    let a = () => i.classList.remove(`down`);
                    return i.addEventListener(`pointerup`, a), i.addEventListener(`pointercancel`, a), i.addEventListener(`pointerleave`, a), i
                },
                n = (cls, label, action) => {
                    let i = V(`button`, {
                        class: `t-btn t-dance ${cls}`,
                        type: `button`,
                        "aria-label": label
                    }, label);
                    return i.addEventListener(`pointerdown`, e => {
                        e.preventDefault(), e.stopPropagation(), i.classList.add(`down`), this.input.touchAction(action)
                    }), i.addEventListener(`pointerup`, () => i.classList.remove(`down`)), i.addEventListener(`pointercancel`, () => i.classList.remove(`down`)), i.addEventListener(`pointerleave`, () => i.classList.remove(`down`)), i
                },
                r = t(`t-jump`, `up`, `Jump`, () => e.touchAction(`jump`)),
                i = t(`t-pause`, `menu`, `Menu`, () => e.touchAction(`pause`));
            this.danceEl = V(`div`, {
                class: `t-dance-pad`
            }, n(`t-dance-up`, `↑`, `danceUp`), n(`t-dance-left`, `←`, `danceLeft`), n(`t-dance-right`, `→`, `danceRight`), n(`t-dance-down`, `↓`, `danceDown`)), this.el = V(`div`, {
                class: `touch`
            }, this.stickEl, this.danceEl, r, i), this.el.addEventListener(`pointerdown`, e => this.down(e)), this.el.addEventListener(`pointermove`, e => this.move(e));
            for (let e of [`pointerup`, `pointercancel`]) this.el.addEventListener(e, e => this.up(e));
            this.el.addEventListener(`touchstart`, e => e.preventDefault(), {
                passive: !1
            }), this.el.addEventListener(`contextmenu`, e => e.preventDefault()), this.setClubMode(!1), this.size(), window.addEventListener(`resize`, () => this.size())
        }
        get radius() {
            return Math.min(window.innerWidth, window.innerHeight) * Pn
        }
        size() {
            this.stickEl.style.setProperty(`--r`, `${this.radius}px`)
        }
        setClubMode(e) {
            this.clubMode = !!e, this.danceEl.classList.toggle(`show`, this.clubMode), this.el.classList.toggle(`club`, this.clubMode)
        }
        down(e) {
            if (e.pointerType !== `mouse`) {
                if (e.target.closest?.(`.t-btn`)) return;
                if (e.preventDefault(), this.el.setPointerCapture?.(e.pointerId), e.clientX < window.innerWidth * .45 && e.clientY > window.innerHeight * .25 && !this.stick) {
                    let t = this.radius,
                        n = E(e.clientX, t * 1.3, window.innerWidth * .45),
                        r = E(e.clientY, t * 1.3, window.innerHeight - t * 1.3);
                    this.stick = {
                        id: e.pointerId,
                        ox: n,
                        oy: r
                    }, this.stickEl.style.left = `${n}px`, this.stickEl.style.top = `${r}px`, this.stickEl.classList.remove(`idle`), this.drag(e.clientX, e.clientY)
                } else this.looks.set(e.pointerId, {
                    x: e.clientX,
                    y: e.clientY
                })
            }
        }
        move(e) {
            if (this.stick?.id === e.pointerId) {
                this.drag(e.clientX, e.clientY);
                return
            }
            let t = this.looks.get(e.pointerId);
            t && (this.input.addTouchLook(e.clientX - t.x, e.clientY - t.y), t.x = e.clientX, t.y = e.clientY)
        }
        drag(e, t) {
            let n = this.stick,
                r = this.radius,
                i = e - n.ox,
                a = t - n.oy,
                o = Math.hypot(i, a),
                s = o / r,
                c = s > Fn,
                l = E((s - .12) / .88, 0, 1),
                u = o > 0 ? i / o : 0,
                d = o > 0 ? a / o : 0;
            this.input.setTouchMove(u * l, -d * l, c);
            let f = Math.min(o, r * Fn);
            this.knob.style.transform = `translate(calc(-50% + ${u*f}px), calc(-50% + ${d*f}px))`, this.stickEl.classList.toggle(`run`, c)
        }
        up(e) {
            this.stick?.id === e.pointerId && this.releaseStick(), this.looks.delete(e.pointerId)
        }
        releaseStick() {
            this.stick = null, this.input.setTouchMove(0, 0, !1), this.stickEl.classList.add(`idle`), this.stickEl.classList.remove(`run`), this.knob.style.transform = ``
        }
        setHidden(e) {
            e !== this.hidden && (this.hidden = e, this.el.classList.toggle(`hidden`, e), e && (this.releaseStick(), this.looks.clear()))
        }
    }
export const Ln = 2600;
export class Rn {
        root;
        sfx;
        layer = V(`div`, {
            class: `screens`
        });
        toasts = V(`div`, {
            class: `toasts`
        });
        stack = [];
        focused = null;
        constructor(e, t) {
            this.root = e, this.sfx = t, e.append(this.layer, this.toasts)
        }
        get open() {
            return this.stack.length > 0
        }
        push(e) {
            this.top?.el.style.setProperty(`display`, `none`), e.el.classList.add(`interactive`), e.el.addEventListener(`mouseover`, e => {
                let t = e.target.closest(`[data-nav]`);
                t && t !== this.focused && this.focus(t)
            }), e.el.addEventListener(`click`, e => {
                e.target.closest(`[data-nav]:not([disabled])`) && this.sfx.uiSelect()
            }), this.layer.append(e.el), this.stack.push(e), requestAnimationFrame(() => this.focus(e.initialFocus(), !1))
        }
        pop() {
            let e = this.stack.pop();
            if (!e) return;
            try {
                e.dispose?.()
            } catch {}
            e.el.classList.add(`leaving`), e.el.addEventListener(`animationend`, () => e.el.remove(), {
                once: !0
            });
            let t = this.top;
            if (!t) {
                this.focused = null;
                return
            }
            t.el.style.removeProperty(`display`), requestAnimationFrame(() => this.focus(this.focused?.isConnected && t.el.contains(this.focused) ? this.focused : t.initialFocus(), !1))
        }
        clear() {
            for (let e of this.stack.splice(0)) {
                try {
                    e.dispose?.()
                } catch {}
                e.el.remove()
            }
            this.focused = null
        }
        handle(e) {
            let t = this.top;
            if (!t) return !1;
            switch (e.action) {
                case `navUp`:
                    this.move(0, -1);
                    break;
                case `navDown`:
                    this.move(0, 1);
                    break;
                case `navLeft`:
                    if (t.onStep?.(-1)) break;
                    this.move(-1, 0);
                    break;
                case `navRight`:
                    if (t.onStep?.(1)) break;
                    this.move(1, 0);
                    break;
                case `confirm`:
                    this.focused && t.el.contains(this.focused) && this.focused.click();
                    break;
                case `back`:
                case `pause`:
                    this.sfx.uiBack(), t.onBack()
            }
            return !0
        }
        toast(e, t = Ln) {
            let n = V(`div`, {
                class: `toast panel`
            }, e);
            for (this.toasts.append(n); this.toasts.children.length > 3;) this.toasts.firstElementChild?.remove();
            setTimeout(() => {
                n.classList.add(`out`), n.addEventListener(`animationend`, () => n.remove(), {
                    once: !0
                })
            }, t)
        }
        get top() {
            return this.stack[this.stack.length - 1]
        }
        focus(e, t = !0) {
            this.focused !== e && (this.focused?.classList.remove(`focus`), t && this.sfx.uiHover(), this.focused = e, e.classList.add(`focus`), e.scrollIntoView({
                block: `nearest`,
                inline: `nearest`
            }))
        }
        move(e, t) {
            let n = [...this.top.el.querySelectorAll(`[data-nav]`)].filter(e => e.offsetParent !== null && !e.hasAttribute(`disabled`)),
                r = this.focused && n.includes(this.focused) ? this.focused : null;
            if (!r) {
                n[0] && this.focus(n[0]);
                return
            }
            let i = r.getBoundingClientRect(),
                a = null,
                o = 1 / 0;
            for (let s of n) {
                if (s === r) continue;
                let n = s.getBoundingClientRect(),
                    c = n.left + n.width / 2 - (i.left + i.width / 2),
                    l = n.top + n.height / 2 - (i.top + i.height / 2),
                    u = c * e + l * t;
                if (u <= 4) continue;
                let d = u + Math.abs(e ? l : c) * 2.5;
                d < o && (o = d, a = s)
            }!a && t && (a = t > 0 ? n[0] : n[n.length - 1]), a && a !== r && this.focus(a)
        }
    }
export const zn = {
        width: 480,
        height: 300
};

export { Nn as Input, In as TouchControls, Rn as UiRoot };
